$(function(){
    users_init_service.page_init();
});

var users_init_service = {
    url: null,

    page_init: function () {
        console.log('users_init_service.page_init start');
        console.log('users_init_service.page_init end');
    },

    modal_init: function () {
        console.log('users_init_service.modal_init start');
        if (typeof onModalLoad == 'function') {
            console.log('onModalLoad call');
            onModalLoad(this.url);
        }

        //Sunity管理GA用
        if (typeof onModalLoadSunity == 'function') {
            console.log('onModalLoadSunity call');
            onModalLoadSunity(this.url);
        }

        console.log('users_init_service.modal_init end');
    }
};
window.users_init_service = users_init_service;
